/**
 * My Recordings Page
 * List and manage sales call recordings
 */

import { useState } from 'react';
import { DashboardLayout } from '@/ui/components/layouts/DashboardLayout';
import { Button } from '@/ui/components/ui/button';
import { Dialog, DialogContent } from '@/ui/components/ui/dialog';
import { Plus } from 'lucide-react';
import { RecordingList } from '@/features/recordings/components/RecordingList';
import { RecordingUpload } from '@/features/recordings/components/RecordingUpload';
import type { Recording } from '@/dto';

export function RecordingsPage() {
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  // const [selectedRecording, setSelectedRecording] = useState<Recording | null>(null);

  const handlePlayRecording = (recording: Recording) => {
    // setSelectedRecording(recording);
    // TODO: Open video player dialog or navigate to player page
    console.log('Playing recording:', recording);
  };

  const handleUploadSuccess = () => {
    setShowUploadDialog(false);
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">My Recordings</h1>
            <p className="text-gray-600 mt-2">
              Upload and manage your sales call recordings
            </p>
          </div>
          <Button
            className="gap-2"
            onClick={() => setShowUploadDialog(true)}
          >
            <Plus size={20} />
            Upload Recording
          </Button>
        </div>

        {/* Recordings List */}
        <RecordingList onPlayRecording={handlePlayRecording} />

        {/* Upload Dialog */}
        <Dialog open={showUploadDialog} onOpenChange={setShowUploadDialog}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <RecordingUpload
              onSuccess={handleUploadSuccess}
              onCancel={() => setShowUploadDialog(false)}
            />
          </DialogContent>
        </Dialog>

        {/* TODO: Add video player dialog for selectedRecording */}
      </div>
    </DashboardLayout>
  );
}
